import { render, staticRenderFns } from "./PollyHeader.vue?vue&type=template&id=35d946b4&"
import script from "./PollyHeader.vue?vue&type=script&lang=js&"
export * from "./PollyHeader.vue?vue&type=script&lang=js&"
import style0 from "./PollyHeader.vue?vue&type=style&index=0&lang=scss&scopes=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports